import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';


@Component({
    selector: 'iOSPopupModal',
    template: `
      <mat-dialog-content>
           <app-locale localeKey="{{key}}" localeView="{{view}}" ></app-locale>
      </mat-dialog-content>
      <mat-dialog-actions>
          <button type="button" class="btn btn-default" (click)="onClose()">
              <app-locale localeKey="CLOSE_BTN_LABEL" localeView="IFRAME" ></app-locale>
          </button>
      </mat-dialog-actions>
        `
})
export class iOSPopupModal {
    key: string;
    view: string;
    constructor(
        public dialogRef: MatDialogRef<iOSPopupModal>,
        @Inject(MAT_DIALOG_DATA) public data: any) { this.key = data.key; this.view = data.view}

    onClose(): void {
        this.dialogRef.close();
    }
}
